import React, { useRef, useState } from 'react'
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    KeyboardAvoidingView,
    Platform,
    ScrollView,
    ActivityIndicator
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, MaterialIcons, AntDesign } from '@expo/vector-icons'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'

const LAInformationOnline = ({ navigation, route }: any) => {
    const {
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        completeOnline,
    } = route.params

    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postlaonline } = useFormsStore()


    const handlesubmit = async (signatureDataURL: string) => {
        const data = {
            essUserKey: intializeStore.initializeData?.userkey,
            entityId: personalstore.personalData?.entityId,
            blockAexemptions: Number(values.blockAexemptions),
            // blockBdependents: Number(values.dependents),
            totalBlockAexemptions: Number(values.blockAexemptions),
            // totalBlockBdependents: Number(values.dependents),
            amount: Number(values.amount),
            maritalStatus: status,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: true,
            sign: signatureDataURL
        }
        const response: any = await postlaonline(data)
        if (response?.success === true) {

            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }
    let status = "";
    if (values.blockAexemptions == 0) {
        status = "1"

    }
    if (values.blockAexemptions == 1) {
        status = "2"
    }
    if (values.blockAexemptions == 2) {
        status = "3"
    }



    return (
        <>
            <View style={{ flex: 1 }}>
                <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                    <View style={[globalStyles.horizontalPadGap]}>
                        <HomeDetailsHeader
                            navLabel="Forms"
                            navScreen="OnboardingForms"
                            title={'LA Withholding Taxation'}
                        />
                    </View>
                </View>
                <SignatureFormView
                    essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                    essUserOnBoardingKey={essUserOnBoardingKey}
                    isSubmitting={loading}
                    onPrevious={() =>
                        navigation.navigate('LaInformationForm', {
                            essUserOnBoardingFormKey,
                            essUserOnBoardingKey,
                            values,
                            mode: "online",
                        })
                    }
                    onSubmit={handlesubmit}

                />
            </View>
        </>
    )
}

export default LAInformationOnline
